import { makeAutoObservable } from 'mobx'

import CheckableMap from '@/models/CheckableMap'

import type { WorkbookPageProblem } from './WorkbookPageProblem'

export class WorkbookPageProblemColl {
  listMap: CheckableMap<number, WorkbookPageProblem>

  constructor(data: WorkbookPageProblem[]) {
    this.listMap = CheckableMap.fromArr(data, 'id')

    makeAutoObservable(this)
  }

  get checkedExampleProblemIdList() {
    return this.listMap.toCheckedValues.flatMap(({ exampleProblem }) =>
      exampleProblem ? [exampleProblem.id] : [],
    )
  }

  get checkedIdList() {
    return this.listMap.toCheckedValues.map(({ id }) => id)
  }

  get toArr() {
    return this.listMap.toArr
  }

  get isFullyChecked() {
    return this.listMap.isFullyChecked
  }

  get isSomeChecked() {
    return this.listMap.isPartChecked
  }

  isChecked(id) {
    return this.listMap.isChecked(id)
  }

  toggleCheck(id) {
    return this.listMap.toggleCheck(id)
  }

  toggleAllChecked = () => {
    this.listMap.toggleAllCheck()
  }

  get toCheckedValues() {
    return this.listMap.toCheckedValues
  }

  clearAllcheck = () => {
    this.listMap.clearAllCheck()
  }

  allCheck() {
    this.listMap.allCheck()
  }

  setCheck(id: number) {
    return this.listMap.setCheck(id)
  }
  get(id: number) {
    return this.listMap.get(id)
  }
}
